import { type StateCreator, create as actualCreate } from 'zustand';

const storeResetFns = new Set<() => void>();

export const resetAllStores = () => {
  for (const resetFunction of storeResetFns) {
    resetFunction();
  }
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
export const create = (<T>() =>
  (stateCreator: StateCreator<T>) => {
    const store = actualCreate(stateCreator);
    const initialState = store.getInitialState();
    storeResetFns.add(() => {
      store.setState(initialState, true);
    });
    return store;
  }) as typeof actualCreate;
